import { CourseScreen } from '@screens/CourseScreen'

/**
 * Visão do produtor sobre a página do curso. Mesma tela do aluno, sem
 * enrollmentId na URL — paridade com /admin_view/courses/:id do hero_theme.
 */
export default function AdminViewCourse() {
  return <CourseScreen />
}
